import PropTypes from 'prop-types';
import React from 'react';

const PeronalityIcon = ({ size, ...props }) => (<svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 100 100"
    {...props}
>
    <circle cx="50" cy="50" r="50" fill="#84DBFF" />
    <path d="M74.1 22.9C68.4 17.2 60.8 14 52.8 14 44.8 14 37.2 17.2 31.5 22.9 25.9 28.6 22.8 36.1 22.7 44.1L17.3 55.1C17 55.6 17.2 56.3 17.7 56.6L22.7 59.6 22.7 75.9C22.7 76.5 23.2 77 23.8 77L33.8 77 33.8 84.9C33.8 85.5 34.3 86 35 86L70.6 86C71.2 86 71.7 85.5 71.7 84.9L71.7 68C78.8 62.2 82.9 53.6 82.9 44.4 82.9 36.3 79.7 28.6 74.1 22.9Z" fill="#E3E3E1" />
    <path d="M51 57.9C50 57.8 49 58.1 48.3 58.7L48.3 53.4 43 53.4C43.6 54.1 44 55 43.8 56.1 43.7 57.6 42.4 58.8 40.9 59 38.9 59.2 37.2 57.6 37.2 55.6 37.2 54.8 37.5 54 38 53.4L32.7 53.4 32.7 68C32.7 68.6 33.2 69.1 33.8 69.1L48.3 69.1 48.3 63.8C48.9 64.3 49.7 64.6 50.6 64.6 52.5 64.6 54.1 62.9 53.9 60.9 53.7 59.3 52.5 58.1 51 57.9Z" fill="#53AAD4" />
    <path d="M35 66.9L35 53.4 32.7 53.4 32.7 68C32.7 68.6 33.2 69.1 33.8 69.1L48.3 69.1 48.3 66.9 35 66.9Z" fill="#1C89B0" />
    <path d="M43.8 56.1C44 55 43.6 54.1 43 53.4L48.3 53.4 48.3 48C47.6 48.6 46.7 49 45.7 48.8 44.2 48.7 42.9 47.4 42.8 45.9 42.6 43.8 44.1 42.1 46.1 42.1 47 42.1 47.7 42.5 48.3 43L48.3 38.5C48.3 38 48 37.6 47.5 37.6L33.8 37.6C33.2 37.6 32.7 38.1 32.7 38.8L32.7 53.4 38 53.4C37.5 54 37.2 54.8 37.2 55.6 37.2 57.6 38.9 59.2 40.9 59 42.4 58.8 43.7 57.6 43.8 56.1Z" fill="#74D0E3" />
    <path d="M36.1 37.6L33.8 37.6C33.2 37.6 32.7 38.1 32.7 38.8L32.7 53.4 35 53.4 35 38.8C35 38.1 35.5 37.6 36.1 37.6Z" fill="#53AAD4" />
    <path d="M59 44C59.8 43.3 60.2 42.4 60.3 41.5L63.4 44.7C63.8 45 64.3 45 64.6 44.7L67.8 41.5C66.9 41.4 66 41 65.3 40.2 64.4 39 64.4 37.2 65.4 36 66.6 34.4 68.9 34.3 70.3 35.7 70.9 36.3 71.3 37.1 71.3 37.9L74.5 34.7C74.8 34.4 74.8 33.9 74.5 33.5L64.8 23.8C64.4 23.4 63.7 23.4 63.2 23.8L53.6 33.5C53.3 33.9 53.3 34.4 53.6 34.7L56.8 37.9C56 38 55.2 38.3 54.6 38.9 53.2 40.3 53.3 42.7 54.9 43.9 56.1 44.9 57.8 44.9 59 44Z" fill="#F5577E" />
    <path d="M52.8 50.7C52.7 51.7 53 52.7 53.6 53.4L48.3 53.4 48.3 58.7C49 58.1 50 57.8 51 57.9 52.5 58.1 53.7 59.3 53.9 60.9 54.1 62.9 52.5 64.6 50.6 64.6 49.7 64.6 48.9 64.3 48.3 63.8L48.3 69.1 62.8 69.1C63.4 69.1 63.9 68.6 63.9 68L63.9 54.2C63.9 53.8 63.6 53.4 63.1 53.4L58.6 53.4C59.1 52.8 59.5 52 59.5 51.1 59.5 49.1 57.8 47.5 55.7 47.8 54.2 47.9 53 49.2 52.8 50.7Z" fill="#74D0E3" />
    <path d="M62.8 66.9L48.3 66.9 48.3 69.1 62.8 69.1C63.4 69.1 63.9 68.6 63.9 68L63.9 65.8C63.9 66.4 63.4 66.9 62.8 66.9Z" fill="#53AAD4" />
</svg>);

PeronalityIcon.propTypes = {
    size: PropTypes.number,
};

PeronalityIcon.defaultProps = {
    size: 100,
};

export default PeronalityIcon;



// WEBPACK FOOTER //
// ./src/client/Components/Icons/Personality.js